<template>
  <div class="cloudExhibition">
    <div class="zxzx_div">
      <ul class="zxzx_ul">
        <li @click="liName('全部', 'all')" :class="{ liBack: tabName === '全部' }">
          <p v-if="tabName === '全部'"></p>
          全部
          <i class="el-icon-caret-right"></i>
        </li>
        <li
          @click="liName('教育', '1')"
          :class="{ liBack: tabName === '教育' }"
        >
          <p v-if="tabName === '教育'"></p>
          教育信息化设备及软件
          <i class="el-icon-caret-right"></i>
        </li>
        <li
          @click="liName('实验', '2')"
          :class="{ liBack: tabName === '实验' }"
        >
          <p v-if="tabName === '实验'"></p>
         实验室、专用教室、实训 <br />平台装备
          <i class="el-icon-caret-right"></i>
        </li>
        <li
          v-for="(item, index) in liList"
          :key="index"
          @click="liName(item.name, item.type)"
          :class="{ liBack: tabName === item.name }"
        >
          <p v-if="tabName === item.name"></p>
          {{ item.title }}
          <i class="el-icon-caret-right"></i>
        </li>
      </ul>
    </div>
    <div class="right_content">
      <div class="title">
        <span>当前位置：&nbsp</span>
        <span>展会</span>
        <span>></span>
        <span>展商查询</span>
        <span style="margin: 0 9px">></span>
        <span>云展览</span>
      </div>

      <div v-if="accountList.length > 0">
        <div
          class="companys"
          v-for="(item, index) in accountList.slice(
            (pageIndex - 1) * pageSize,
            pageIndex * pageSize
          )"
          :key="index"
        >
          <div class="companysTop">
            <div class="left">
              <div class="img_div">
                <img :src="$getSrc(item.cLogo)" alt />
              </div>
            </div>
            <div class="right">
              <p>{{ item.cName }}</p>
              <p>{{ item.pLandline }}</p>
            </div>
          </div>
          <div class="companysContent">
            <div class="product">
              <el-row type="flex">
                <el-col
                  :span="6"
                  v-for="(o, index) in item.productList.slice(
                    (pageIndex2 - 1) * pageSize2,
                    pageIndex2 * pageSize2
                  )"
                  :key="index"
                >
                  <div class="product_event" @click="productInfo(o)">
                    <p class="img_p">
                      <img :src="$getSrc(o.image)" alt />
                    </p>
                    <p class="text_p">{{ o.title }}</p>
                  </div>
                </el-col>
              </el-row>
            </div>
          </div>
        </div>

        <div class="fenye">
          <el-pagination
            background
            @current-change="currentChangeHandle"
            :current-page="pageIndex"
            :page-size="pageSize"
            :total="totalPage"
            layout="prev, pager, next, slot "
          >
            <el-input v-model="tiaoPage" class="tiaoInp"></el-input>
            <el-button class="tiaoBtn" @click="transfer">跳转</el-button>
          </el-pagination>
        </div>
      </div>

      <div class="noData" v-else>暂无数据</div>
    </div>
  </div>
</template>
<script>
export default {
  name: "cloudExhibition",
  components: {},
  data() {
    return {
      tabName: "全部",
      pageIndex2: 1,
      pageSize2: 6, // 每个企业展示产品数
      pageSize: 5, // 每页条数
      pageIndex: 1, // 当前页
      totalPage: 0, // 总条数
      accountList: [], // 企业list
      tiaoPage: "",
      totalIndex: 0,
      liList: [
        // { title: "全部", name: "全部", type: "all" },
        // { title: "教育信息化设备及软件", name: "教育", type: "1" },
        { title: "校园后勤、节能与环保设备", name: "后勤", type: "3" },
        { title: "体音美及图书馆类设备", name: "图书", type: "4" },
        { title: "学前教育装备及玩教具", name: "教具", type: "5" },
      ],
    };
  },
  mounted() {
    this.liName("全部", "all");
  },
  activated() {
    this.liName("全部", "all");
  },
  methods: {
    liName(e, type) {
      this.tabName = e;
      this.$http({
        url: "getAccoutAndProduct",
        method: "post",
        params: {
          productType: type,
        },
      }).then(({ data }) => {
        let { code, accountEntities } = data;
        if (code === 0) {
          this.totalPage = accountEntities.length;
          this.totalIndex = Math.ceil(this.totalPage / this.pageSize);
          this.accountList = accountEntities;
        }
      });
    },

    // 产品详情
    productInfo(pro) {
      sessionStorage.setItem("accountId",pro.accountId);
      this.$router.push({
        path: "/exhibitorHome/product",
        query: {
          exhibitor_id: pro.id,
          id: pro.accountId,
        },
      });
    },

    // 跳转
    transfer() {
      if (this.tiaoPage * 1 > this.totalIndex) {
        this.$message.error("已超出总页数！");
      } else {
        this.pageIndex = this.tiaoPage * 1;
      }
    },

    // 每页数
    sizeChangeHandle(val) {
      this.pageSize = val;
      this.pageIndex = 1;
    },
    // 当前页
    currentChangeHandle(val) {
      this.pageIndex = val;
    },
  },
};
</script>
<style lang="scss">
.cloudExhibition {
  height: 2494px !important;
  .fenye {
    height: 32px;
    // text-align: center;
    margin: 40px 0 36px 0;
    .el-icon-arrow-left:before {
      content: "上一页";
    }
    .el-icon-arrow-right:before {
      content: "下一页";
    }
    .el-pagination {
      padding: 0;
    }
    .btn-prev,
    .btn-next,
    .tiaoBtn {
      width: 54px;
      height: 32px;
      background-color: #eeeeee;
      line-height: 54px;
      color: #424242 !important;
    }
    .el-pager {
      li {
        width: 32px;
        height: 32px;
        background-color: #eeeeee;
        color: #525252;
        line-height: 32px;
      }
    }
    .el-pagination.is-background .el-pager li {
      &:hover {
        color: #143372;
      }
    }
    .el-pagination.is-background .el-pager li:not(.disabled).active {
      background-color: #17327e;
      &:hover {
        color: #ffffff;
      }
    }
    .tiaoInp {
      width: 32px;
      height: 32px;
      .el-input__inner {
        padding: 0;
        border-radius: 0;
        height: 32px;
      }
    }
    .tiaoBtn {
      border-radius: 2px;
      margin-left: 8px;
    }
    .el-pagination span:not([class*="suffix"]),
    .el-pagination button {
      line-height: 32px;
    }
  }
}
</style>
<style lang="scss" scoped>
.cloudExhibition {
  height: 1177px;
  .liBack {
    background-color: #ffffff !important;
  }
  .zxzx_div {
    width: 332px;
    height: 377px;
    border: 1px solid #e2e2e2;
    float: left;
    .zxzx_ul {
      li {
        height: 63px;
        line-height: 64px;
        background-color: #f0f0f0;
        border-bottom: 1px solid #e2e2e2;
        padding-left: 21px;
        cursor: pointer;
        position: relative;
        i {
          position: absolute;
          right: 20px;
          top: 50%;
          margin-top: -8px;
        }
        p {
          width: 3px;
          height: 64px;
          background-color: #143372;
          position: absolute;
          left: 0;
        }
      }
      li:nth-child(3) {
        height: 51px;
        padding-top: 12px;
        line-height: 20px;
        p {
          top: -1px;
        }
      }
    }
  }
  .right_content {
    width: 845px;
    float: right;
    .title {
      height: 44px;
      line-height: 44px;
      padding-left: 17px;
      color: #b6b6b6;
      font-size: 12px;
      box-shadow: -3px 0px 3px #f6f6f6, 0px -3px 3px #f6f6f6, 3px 0 3px #f6f6f6,
        0px 3px 3px #f6f6f6;
      span:nth-child(3) {
        margin: 0 9px;
      }
    }
    .companys {
      width: 844px;
      min-height: 542px;
      border: 1px solid #f3f3f3;
      margin-top: 20px;
      .companysTop {
        height: 115px;
        border-bottom: 1px solid #f3f3f3;
        .left {
          width: 314px;
          height: 100%;
          float: left;
          .img_div {
            width: 217px;
            height: 80px;
            margin: 20px 0 0 24px;
            text-align: center;
            img {
              max-width: 100%;
              max-height: 100%;
              width: auto;
              height: auto;
              display: inline-block;
              vertical-align: middle;
            }
          }
        }
        .right {
          width: 530px;
          height: 100%;
          float: right;
          font-size: 16px;
          line-height: 33px;
          p:first-child {
            margin-top: 26px;
          }
        }
      }
      .companysContent {
        padding: 0 0 15px 21px;
        .product_event {
          width: 188px;
          height: 188px;
          border: 1px solid #f3f3f3;
          border-radius: 10px;
          cursor: pointer;
          .img_p {
            width: 162px;
            height: 108px;
            margin: 13px 14px 0;
            text-align: center;
            img {
              max-width: 100%;
              max-height: 100%;
              width: auto;
              height: auto;
              display: inline-block;
              vertical-align: middle;
            }
          }
          .text_p {
            font-size: 16px;
            color: #333333;
            width: 162px;
            margin: 12px 0 0 14px;
            line-height: 23px;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
          }
        }
        .el-row {
          flex-wrap: wrap;
        }
        .el-col {
          margin-top: 15px;
        }
      }
    }
  }
  .noData {
    text-align: center;
    line-height: 100px;
  }
}
</style>